import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { portalForHostname } from '../utils/portalExperience';
import { getStoredUser } from '../utils/featureAccess';
import { homePathForUser } from '../utils/homePath';
import SeoHead from './SeoHead';

export function PortalNavigation() {
    const portal = portalForHostname();
    const user = getStoredUser();
    if (!portal) return null;
    return (
        <header style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', flexWrap: 'wrap', gap: 20, padding: '16px 24px', background: '#fff', borderBottom: '1px solid #d5dedc' }}>
            <Link to={portal.loginPath} aria-label={`${portal.productName} home`}>
                <img src="/site-assets/tyson-engage/tyson-engage-lockup.svg" alt={portal.productName} width="190" height="90" style={{ display: 'block', maxWidth: '100%' }} />
            </Link>
            <nav aria-label={`${portal.productName} navigation`} style={{ display: 'flex', gap: 20, flexWrap: 'wrap' }}>
                <Link to={user?.token ? homePathForUser(user) : portal.loginPath}>{user?.token ? 'Workspace' : 'Sign in'}</Link>
                {user?.token && <Link to="/search">Search</Link>}
                <Link to="/help">Support</Link>
            </nav>
        </header>
    );
}

export function PortalFooter() {
    const portal = portalForHostname();
    if (!portal) return null;
    return <footer style={{ padding: 24, display: 'flex', justifyContent: 'center', gap: 20, flexWrap: 'wrap', color: '#004c50', background: '#f4f8f6' }}>
        <span>{portal.productName}</span><Link to="/help">Support</Link><Link to="/privacy">Privacy Policy</Link><Link to="/legal">Terms of Service</Link>
    </footer>;
}

export function PortalPublicPage({ title, children, embedded = false }) {
    const portal = portalForHostname();
    const location = useLocation();
    const Content = embedded ? 'div' : 'main';
    return <div style={{ minHeight: '100vh', background: '#f4f8f6', color: '#0f2a2c', fontFamily: 'var(--brand-font, sans-serif)' }}>
        <SeoHead title={title ? `${title} | ${portal?.productName || 'Tyson Engage'}` : portal?.productName} path={location.pathname} noindex image="/agencies/tyson-logo.png" />
        <PortalNavigation />
        <Content style={embedded ? undefined : { maxWidth: 880, margin: '0 auto', padding: '36px 24px', lineHeight: 1.7 }}>
            {title && <h1>{title}</h1>}
            {children}
        </Content>
        <PortalFooter />
    </div>;
}

export function PortalSupportPage() {
    return <PortalPublicPage title="Tyson Engage support">
        <p>For help with your account or workspace, contact your branch administrator or the team that provided your invitation.</p>
        <p>If you cannot sign in, use the password recovery process with the email address on your account.</p>
        <Link to="/forgot-password">Reset your password</Link>
    </PortalPublicPage>;
}

export function PortalAccessPage() {
    return <PortalPublicPage title="Access Tyson Engage">
        <p>Sign in with your existing account, or open the invitation supplied by your branch.</p>
        <p>To request access, contact your branch administrator.</p>
        <Link to="/agency-agent-invite">Use an invitation PIN or link</Link>
    </PortalPublicPage>;
}

export function PortalUnavailablePage() {
    return <PortalPublicPage title="Page not available">
        <p>This page is not available in Tyson Engage. Use your workspace or contact your branch administrator for help.</p>
    </PortalPublicPage>;
}
